

export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.accessToken) {
    return { Authorization: 'Bearer ' + user?.accessToken};
  } else return; 
  // {
  //   return console.log('logged out');
  //   window.open(window.location.origin + "/auth/signin-2");
  // }
}